import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import { useTheme } from '@mui/material/styles';
import ScrollableTabs from 'tailwind-components/ScrollableTabs/ScrollableTabs';

export const DASHBOARD_SECTION_IDS = {
  AGENTS_TABLE: 'agents-table',
  ONBOARDING: 'onboarding'
};

function SectionTabLabel({ labelText, selected, icon }) {
  const theme = useTheme();

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='center'
      flexWrap='nowrap'
      spacing={1}
      useFlexGap
      sx={{
        typography: 'body2',
        fontWeight: selected ? 600 : 500,
        whiteSpace: 'nowrap',
        color: selected
          ? theme.palette.primary.main
          : theme.palette.text.secondary
      }}
    >
      {icon ? (
        <Box
          component='span'
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            color: 'inherit',
            '& svg': {
              width: 18,
              height: 18,
              display: 'block'
            }
          }}
          aria-hidden='true'
        >
          {icon}
        </Box>
      ) : null}
      <span>{labelText}</span>
    </Stack>
  );
}

SectionTabLabel.propTypes = {
  labelText: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  icon: PropTypes.node
};

function AgencyDashboardSectionTabs({
  tabs,
  value,
  onChange,
  ariaLabel = 'Dashboard sections'
}) {
  const handleChange = (_event, nextId) => {
    onChange(nextId);
  };

  return (
    <div className='flex w-full min-w-0 flex-col'>
      <ScrollableTabs
        value={value}
        onChange={handleChange}
        aria-label={ariaLabel}
        tabPaddingY={1}
      >
        {tabs.map(({ id, label, icon }) => (
          <Tab
            key={id}
            value={id}
            label={
              <SectionTabLabel
                labelText={label}
                selected={value === id}
                icon={icon}
              />
            }
          />
        ))}
      </ScrollableTabs>
    </div>
  );
}

AgencyDashboardSectionTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string
};

export default AgencyDashboardSectionTabs;
